<script setup>
import {ref} from "vue";
import marketsService from "@/services/markets.service";
import {constants} from "@/views/search/searchConstants";
import PulseLoader from "vue-spinner/src/MoonLoader.vue";

const emit = defineEmits(['reportLoaded']);

const showModal = ref(false);
const loading = ref(false);
const blobUrl = ref(null);
const subsectorName = ref(null);
const readReport = ref(false);

async function getData() {
    loading.value = true;
    const {data} = await marketsService.getReport(subsectorName.value, readReport.value ? 1 : 0);

    blobUrl.value = URL.createObjectURL(data);
    loading.value = false;
    emit('reportLoaded')
}

function open(clusterName, read) {
    subsectorName.value = clusterName;
    readReport.value = read;
    getData();

    if (blobUrl.value) {
        URL.revokeObjectURL(blobUrl.value);
        blobUrl.value = null;
    }

    showModal.value = true;
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" modal-class="modal--sector modal-w-xxxl" hide-footer>
        <template #modal-header>
            <h5 class="modal-title">Sector Partnership Landscape</h5>
            <a v-if="blobUrl" class="link link--download mr-4 ml-auto" :href="blobUrl" download="Sector Partnership Landscape">Download</a>
            <button @click="showModal = false" class="close"></button>
        </template>

        <div style="min-height: 400px">
            <PulseLoader :loading="loading" :color="constants.spinnerColor"/>

            <iframe
                style="width: 100%; height: 80vh; border: 0;"
                v-if="blobUrl"
                :src="blobUrl"
            ></iframe>
        </div>
    </b-modal>
</template>

<style scoped>

</style>
